module.exports = __webpack_public_path__ + "media/icons/naped-tyl-blue@3x-c4c30c74.svg";